(function () {
  function initTiers(section) {
    var mobile = section.querySelector('[data-tiers-mobile]');
    if (!mobile) return;

    var headerTrack = mobile.querySelector('[data-header-track]');
    var valuesTrack = mobile.querySelector('[data-values-track]');
    var prevBtn = mobile.querySelector('[data-tier-prev]');
    var nextBtn = mobile.querySelector('[data-tier-next]');
    var showMoreBtn = mobile.querySelector('[data-show-more]');
    var dots = mobile.querySelectorAll('[data-tiers-dots] .gc-tier-dot');
    var totalTiers = dots.length;
    var currentIndex = 0;

    function goTo(index) {
      if (index < 0 || index >= totalTiers) return;
      currentIndex = index;
      var offset = -index * 100;
      headerTrack.style.transform = 'translateX(' + offset + '%)';
      valuesTrack.style.transform = 'translateX(' + offset + '%)';
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === currentIndex);
      });
      prevBtn.classList.toggle('is-hidden', currentIndex === 0);
      nextBtn.classList.toggle('is-hidden', currentIndex === totalTiers - 1);
    }

    // Init next btn state
    if (totalTiers <= 1) nextBtn.classList.add('is-hidden');

    prevBtn.addEventListener('click', function () { goTo(currentIndex - 1); });
    nextBtn.addEventListener('click', function () { goTo(currentIndex + 1); });

    dots.forEach(function (dot, i) {
      dot.style.cursor = 'pointer';
      dot.addEventListener('click', function () { goTo(i); });
    });


    // Show more: animate extra rows with max-height transition
    var extraLabels = mobile.querySelector('[data-extra-labels]');
    var extraValues = mobile.querySelectorAll('[data-extra-values]');

    if (showMoreBtn) {
      var hasExtra = extraLabels && extraLabels.children.length > 0;
      if (!hasExtra) {
        showMoreBtn.style.display = 'none';
      } else {
        showMoreBtn.addEventListener('click', function () {
          var expanded = showMoreBtn.getAttribute('aria-expanded') === 'true';
          if (!expanded) {
            // Expand
            extraLabels.style.maxHeight = extraLabels.scrollHeight + 'px';
            extraValues.forEach(function (el) {
              el.style.maxHeight = el.scrollHeight + 'px';
            });
            showMoreBtn.textContent = '- SHOW LESS';
          } else {
            // Collapse
            extraLabels.style.maxHeight = '0';
            extraValues.forEach(function (el) {
              el.style.maxHeight = '0';
            });
            showMoreBtn.textContent = '+ SHOW MORE';
          }
          showMoreBtn.setAttribute('aria-expanded', String(!expanded));
        });
      }
    }
  }

  document.querySelectorAll('.growth-circle-tiers').forEach(initTiers);
})();
